import './transferInfo.scss';

import React, { useEffect } from 'react';

import { recordEvent, PAGE_PRODUCT } from 'utilities/uTagging';
import { PATH_IDENTITY_TRANSFER, PATH_IDENTITY_TRANSFER_EVENT } from 'constants/uTagConstants/paths';
import { EVENT_ONBOARDING } from 'constants/uTagConstants/RAConstants';
import {
    isCountryGermany,
    isCountryNetherlands,
    isCountryPortugal,
    isCountrySpain,
} from 'utilities/multiLanguageHelper';
import getEncrypted from 'utilities/getEncrypted';
import { TransferDataContent } from 'components/newIdentifyMethods/transferInfo/TransferDataContent/TransferDataContent';
import { OTP_STEP_ACTIVE } from 'constants/featureFlagging';
import { TransferComissionAdvise } from 'components/newIdentifyMethods/transferInfo/TransferComissionAdvice/TransferComissionAdvise';
import { ContinueWithoutTransferAdvise } from 'components/newIdentifyMethods/transferInfo/ContinueWithoutTransferAdvise/ContinueWithoutTransferAdvise';
import { TransferHeaderContent } from 'components/newIdentifyMethods/transferInfo/TransferHeaderContent/TransferHeaderContent';

const TransferInfo = ({ userProfile, flags }) => {
    useEffect(() => {
        recordEvent(
            PATH_IDENTITY_TRANSFER,
            PAGE_PRODUCT,
            PATH_IDENTITY_TRANSFER_EVENT,
            'transferencia',
            userProfile.recordId,
            userProfile.userId,
            '',
            userProfile.investmentType,
            getEncrypted(userProfile.docNumber),
            {
                categoriaEvento: EVENT_ONBOARDING,
                accionEvento: PATH_IDENTITY_TRANSFER_EVENT,
                etiquetaEvento: 'transferencia',
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isOtpStepActive = flags?.get(OTP_STEP_ACTIVE) ?? false;
    const showTransferContent = isCountrySpain() || !isOtpStepActive;

    const showWarningMessage = showTransferContent && isCountryPortugal();
    const showWarningMessageOutsideTransferContent = !showTransferContent && isCountryPortugal();

    const showInfoMessage = (isCountryGermany() || isCountryNetherlands()) && !isOtpStepActive;

    return (
        <section className="transfer-content">
            <TransferHeaderContent />
            {showTransferContent && (
                <TransferDataContent
                    iban={userProfile.iban}
                    userName={userProfile.name}
                    userLastName={userProfile.lastName}
                    userSecondLastName={userProfile.secondLastName}
                    renderWarningMessage={() => showWarningMessage && <TransferComissionAdvise />}
                />
            )}
            {showWarningMessageOutsideTransferContent && <TransferComissionAdvise />}
            {showInfoMessage && <ContinueWithoutTransferAdvise />}
        </section>
    );
};

export { TransferInfo };
